export function getPasswordValidity(pwd) {
    return {
        length: pwd.length >= 8,
        uppercase: /[A-Z]/.test(pwd),
        lowercase: /[a-z]/.test(pwd),
        number: /[0-9]/.test(pwd),
        special: /[^A-Za-z0-9]/.test(pwd)
    };
}

export function isPasswordValid(pwd) {
    return Object.values(getPasswordValidity(pwd)).every(Boolean);
}
